import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PanelsContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(4),
  maxWidth: theme.breakpoints.values.lg,
  margin: '0 auto',

  '& .noBorder td': {
    border: 'none',
  },

  '& .offsetCheck': {
    position: 'relative',
    left: 15,
    padding: 0,
  },
}));

export const Accordion = styled('div')(({ theme }) => ({
  '& .accordionRow': {
    border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1),
    boxSizing: 'border-box',

    '&.notLast': {
      borderBottom: 'none',
    },

    '& .titlerow': {
      cursor: 'pointer',

      '& .MuiIcon-root': {
        marginLeft: 'auto',
      },
    },
  },
}));

export const Heading = styled(Typography)({});
